import React from "react";
import { NoEventsContainer } from "./NewEvents.styles";
import Images from "config/Images";

interface NoEventsPlaceholderProps {
  message?: string;
  imageUrl?: string;
}

const NoEventsPlaceholder: React.FC<NoEventsPlaceholderProps> = ({
  message = "You have no upcoming events planned",
  imageUrl = Images.noEvent,
}) => {
  return (
    <NoEventsContainer>
      <img src={imageUrl} alt="No events found" />
      <h2>{message}</h2>
    </NoEventsContainer>
  );
};

export default NoEventsPlaceholder;
